module.exports = __webpack_public_path__ + "img/GGJLogo.ef4e3d20.jpg";